module.exports = __webpack_public_path__ + "img/FCC.8ceca73c.jpg";